export const GET_BLOCK_CHAIN = 'GET_BLOCK_CHAIN'
export const GET_BLOCK_CONTRACT = 'GET_BLOCK_CONTRACT'
export const GET_UPPER_CHAIN = 'GET_UPPER_CHAIN'
export const GET_CHAIN_ORG = 'GET_CHAIN_ORG'
export const GET_CHAIN_NODE = 'GET_CHAIN_NODE'
export const GET_OFFCHAIN_NODE = 'GET_OFFCHAIN_NODE'
export const GET_OFFCHAIN_CHAN_LIST = 'GET_OFFCHAIN_CHAN_LIST' //链下扩容通道
export const GET_CHAIN_USER = 'GET_CHAIN_USER'
export const GET_CHAIN_VOTE = 'GET_CHAIN_VOTE'
export const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB'
export const GET_ACTIVE_USERID = 'GET_ACTIVE_USERID'
export const GET_ACTIVE_CIPHERTEXTID = 'GET_ACTIVE_USERID'
export const GET_ARCHIVING_DETAIL = 'GET_ARCHIVING_DETAIL' //查询归档详情
